import { ServiceRequest } from '../../types';

export type PaymentFlowRequestType = 'company' | 'craftsman';

const SERVICE_ENTITY_UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * 是否依「統包／公司固定價」計佣（獨立模組，避免 serviceRequestService ↔ paymentService 循環依賴）
 */
export function resolveIsCompanyFixedForRequest(
  request: Partial<
    ServiceRequest & {
      pricing_mode?: string;
      company_id?: string | null;
      craftsman_id?: string | null;
    }
  > & {
    companyId?: string | null;
    craftsmanId?: string | null;
  },
  opts?: {
    companyIdOverride?: string | null;
    paymentFlowRequestType?: PaymentFlowRequestType;
  }
): boolean {
  if (opts?.paymentFlowRequestType === 'company') return true;

  const mode = request.pricingMode ?? request.pricing_mode ?? 'hourly';
  if (mode === 'company_fixed') return true;

  const companyId =
    opts?.companyIdOverride ??
    request.companyId ??
    request.company_id ??
    null;
  const craftsmanId = request.craftsmanId ?? request.craftsman_id ?? null;

  const hasCompany =
    typeof companyId === 'string' && SERVICE_ENTITY_UUID.test(companyId);
  const hasCraftsman =
    typeof craftsmanId === 'string' &&
    SERVICE_ENTITY_UUID.test(craftsmanId) &&
    craftsmanId !== 'temp-craftsman-id';

  return hasCompany && !hasCraftsman;
}
